import React from 'react';
import SvgComponent from './svg';


export default function CurrentLocationIcon(props) {
  return <SvgComponent {...props} />;
}
